import ResourceTypeahead from './ResourceTypeahead';

export default ResourceTypeahead;
